import { useEffect, useState, useRef } from "react";

const Mailchimp = () => {
  const [formData, setFormData] = useState({
    EMAIL: "",
    FNAME: "",
    LNAME: "",
    MMERGE3: "",
    MMERGE4: "",
    MMERGE5: "",
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [message, setMessage] = useState({ text: "", isError: false });
  const [formValid, setFormValid] = useState(false);

  const logo = useRef();
  const form = useRef();
  const success = useRef();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  useEffect(() => {
    const isValid =
      formData.EMAIL.trim() !== "" &&
      formData.FNAME.trim() !== "" &&
      formData.LNAME.trim() !== "";
    setFormValid(isValid);
  }, [formData]);

  useEffect(() => {
    logo.current.classList.add("active");
    setTimeout(() => {
      logo.current.classList.remove("active");
      form.current.classList.add("active");
    }, 3000);
  }, []);

  const submitSuccessful = () => {
    form.current.classList.remove("active");
    success.current.classList.add("active");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Double check validation before submitting
    if (!formValid) {
      setMessage({
        text: "Please fill in all required fields",
        isError: true,
      });
      return;
    }

    setIsSubmitting(true);
    setMessage({ text: "", isError: false });

    try {
      const response = await fetch(
        "https://club.us12.list-manage.com/subscribe/post?u=0e2d65035d482d6c401c2a75e&id=6620f824b6&f_id=00f2f1e0f0",
        {
          method: "POST",
          mode: "no-cors",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
          body: new URLSearchParams(formData).toString(),
        }
      );

      setMessage({ text: "Thank you for subscribing!", isError: false });
      submitSuccessful();

      setFormData({
        EMAIL: "",
        FNAME: "",
        LNAME: "",
        MMERGE3: "",
        MMERGE4: "",
        MMERGE5: "",
      });
    } catch (error) {
      setMessage({
        text: "An error occurred. Please try again.",
        isError: true,
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <div className={`dreamland__logo-wrapper`} ref={logo}>
        <img
          className="dreamland__logo"
          src="assets/dreamland.png"
          alt="DREAMLAND 666"
        />
      </div>

      <section className="dreamland__form-wrapper" ref={form}>
        <div>
          <h1>Welcome 2 dreamland</h1> 
          <br />
          <br />
          Dreamland is a space for connection between peach and her people who
          love to join her for a dance. It’s a series of memories & moments
          (((in both the physical and digital world))).
          <br />
          <br />
          In a world where we are forced to connect mainly on the digital plane,
          controlled by algorithmic forces which do not favor artists or
          connection, there is a heightened need to gather beyond this.
          <br />
          <br />
          Dreamland is a project which hopes to break away from this, and
          connect many cuties worldwide (((without the means of capitalist tech
          overlords)))
          <br />
          <br />
          <ul>Dreamland will attempt to offer peach and her lil angels
            <li>An open line
          of communication</li>
            <li>Fun niche stupid updates</li>
            <li>A connectedness between
          those that love to connect via the dance</li>
            <li>A break in the usual pattern
          of social connectivity</li>
          </ul>
              
          <br />
          <br />
          All of this will happen starting in 2025 and beyond, via cute emails +
          updates, events, etc
          <br />
          <br />
          {/* More to come ~~~ to join us in dreamland please enter your email
          below:
          <br />
          <br /> */}
As a thank you for joining us in dreamland, we would like to send all dreamland ppl the brand new dreamland club card&trade;. Pls check your emails for info on how to get yours &#60;3
          <br />
          <br />
          More to come ~ to join us in dreamland please enter your email below ~
        </div>

        <div className="dreamland__form-container" id="mc_embed_shell">
          <div id="mc_embed_signup">
            <form
              onSubmit={handleSubmit}
              id="mc-embedded-subscribe-form"
              name="mc-embedded-subscribe-form"
              className="validate"
              noValidate
            >
              <div id="mc_embed_signup_scroll">
                {/* <h1>join us in dreamland</h1>
                    <br />
          <br /> */}
                <div className="indicates-required">
                  <span className="asterisk">*</span> indicates required
                </div>
                <div className="mc-field-group">
                  <input
                    type="email"
                    placeholder="Email Address *"
                    name="EMAIL"
                    className="required email"
                    id="mce-EMAIL"
                    required
                    value={formData.EMAIL}
                    onChange={handleChange}
                  />
                </div>
                <div className="mc-field-group">
                  <input
                    type="text"
                    name="FNAME"
                    className="required text"
                    id="mce-FNAME"
                    required
                    placeholder="First Name *"
                    value={formData.FNAME}
                    onChange={handleChange}
                  />
                </div>
                <div className="mc-field-group">
                  <input
                    type="text"
                    name="LNAME"
                    className="required text"
                    id="mce-LNAME"
                    required
                    placeholder="Last Name *"
                    value={formData.LNAME}
                    onChange={handleChange}
                  />
                </div>
                <div className="mc-field-group">
                  <input
                    type="text"
                    name="MMERGE3"
                    className="text"
                    id="mce-MMERGE3"
                    placeholder="Location (city / country)"
                    value={formData.MMERGE3}
                    onChange={handleChange}
                  />
                </div>
                <p className="dreamland__text-break">Ask Peach a question!</p>
                <div className="mc-field-group">
                  <select
                    name="MMERGE4"
                    className=""
                    id="mce-MMERGE4"
                    value={formData.MMERGE4}
                    onChange={handleChange}
                  >
                    <option value="">Subject</option>
                    <option value="DJing">DJing</option>
                    <option value="Production">Production</option>
                    <option value="Lifestyle">Lifestyle</option>
                  </select>
                </div>
                <div className="mc-field-group">
                  <input
                    type="text"
                    name="MMERGE5"
                    className="text"
                    id="mce-MMERGE5"
                    placeholder="Question"
                    value={formData.MMERGE5}
                    onChange={handleChange}
                  />
                </div>
                <div id="mce-responses" className="clear">
                  <div
                    className="response"
                    id="mce-error-response"
                    style={{ display: "none" }}
                  ></div>
                  <div
                    className="response"
                    id="mce-success-response"
                    style={{ display: "none" }}
                  ></div>
                </div>
                <div
                  aria-hidden="true"
                  style={{ position: "absolute", left: "-5000px" }}
                >
                  <input
                    type="text"
                    name="b_0e2d65035d482d6c401c2a75e_6620f824b6"
                    tabIndex="-1"
                    value=""
                  />
                </div>
                <div className="clear">
                  <input
                    type="submit"
                    name="subscribe"
                    id="mc-embedded-subscribe"
                    className={`dreamland__submit ${formValid ? "active" : ""}`}
                    value={isSubmitting ? "Subscribing..." : "Subscribe"}
                    // disabled={isSubmitting || !formValid}
                  />
                </div>
                {message.text && (
                  <div
                    className={`message ${
                      message.isError ? "error" : "success"
                    }`}
                  >
                    {message.text}
                  </div>
                )}
              </div>
            </form>
          </div>
        </div>
      </section>

      <section className="dreamland__success-wrapper" ref={success}>
        <div class="dreamland__card-container">
          <div class="dreamland__card-front">
            <img
              className="dreamland__card"
              src="assets/front.png"
              alt="DREAMLAND 666"
            />
          </div>
          <div class="dreamland__card-back">
            <img
              className="dreamland__card "
              src="assets/back.png"
              alt="DREAMLAND 666"
            />
          </div>
        </div>
        <div className="dreamland__success-message ">
          Follow the instructions in your inbox to get your Dreamland card x
        </div>
      </section>
    </>
  );
};

export default Mailchimp;
